import { useEffect, useState } from "react";

// Slim marquee ribbon between sections - gives the site a "live system" feel.
const items = [
  "BLUDE · LIVE 24/7",
  "BRIDGING THE GAP BETWEEN CRISIS AND SURVIVAL",
  "LIFE SCIENCE · TECH · BIOMATERIALS",
  "EMERGENCY · TRAUMA · WOUND CARE",
  "MADURAI · INDIA",
];

export const Ticker = () => {
  const row = [...items, ...items, ...items];
  const [pause, setPause] = useState(false);
  useEffect(() => {
    const onVis = () => setPause(document.hidden);
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  return (
    <div
      data-testid="ticker-strip"
      className="relative overflow-hidden border-y border-white/5 bg-[#0A0A0C] py-5"
    >
      <div
        className={`flex gap-12 whitespace-nowrap animate-marquee ${
          pause ? "[animation-play-state:paused]" : ""
        }`}
        style={{ width: "max-content" }}
      >
        {row.map((t, i) => (
          <span
            key={i}
            className="flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-white/50"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF2400]" />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};
